import { alpha } from '@mui/material/styles';
import { alignProperty } from '@mui/material/styles/cssUtils';
import { tableCellClasses } from '@mui/material/TableCell';
import { tableRowClasses } from '@mui/material/TableRow';
import { border, borderBottom, borderColor, borderLeft, borderRight, margin, padding, textAlign } from '@mui/system';

// // ----------------------------------------------------------------------

// export function table(theme) {
//   return {
//     MuiTableContainer: {
//       styleOverrides: {
//         root: {
//           position: 'relative',
//         },
//       },
//     },
//     MuiTableRow: {
//       styleOverrides: {
//         root: {
//           [`&.${tableRowClasses.selected}`]: {
//             backgroundColor: alpha(theme.palette.primary.dark, 0.04),
//             '&:hover': {
//               backgroundColor: alpha(theme.palette.primary.dark, 0.08),
//             },
//           },
//           '&:last-of-type': {
//             [`& .${tableCellClasses.root}`]: {
//               borderColor: 'transparent',
//             },
//           },
//         },
//       },
//     },
//     MuiTable: {
//        styleOverrides: {
//        root: {
//                  fontSize: 10.5, // Ensure the overall font size is small
//               },
//              },
//            },
//     MuiTableCell: {
//       styleOverrides: {
//         root: {
//           fontSize: 10.5, // Minimized font size for table cells
//           padding: theme.spacing(0.5), // Minimal padding for compactness
//           borderBottomStyle: 'dashed',
//         },
//         head: {
//           fontSize: 11,
//           color: theme.palette.text.secondary,
//           fontWeight: theme.typography.fontWeightSemiBold,
//           backgroundColor: theme.palette.background.neutral,
//         },
//         stickyHeader: {
//           backgroundColor: theme.palette.background.paper,
//           backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.neutral} 0%, ${theme.palette.background.neutral} 100%)`,
//         },
//         paddingCheckbox: {
//           paddingLeft: theme.spacing(1),
//         },
//       },
//     },

//     MuiTablePagination: {
//       styleOverrides: {
//         root: {
//           width: '100%',
//         },
//         toolbar: {
//           height: 64,
//         },
//         actions: {
//           marginRight: 8,
//         },
//         select: {
//           paddingLeft: 8,
//           '&:focus': {
//             borderRadius: theme.shape.borderRadius,
//           },
//         },
//         selectIcon: {
//           right: 4,
//           width: 16,
//           height: 16,
//           top: 'calc(50% - 8px)',
//         },
//       },
//     },
//   };
// }

// -------------------------------------updated table.js--------------------------------------------

// export function table(theme) {
//   return {
//     MuiTableContainer: {
//       styleOverrides: {
//         root: {
//           position: 'relative',
//         },
//       },
//     },
//     MuiTableRow: {
//       styleOverrides: {
//         root: {
//           [`&.${tableRowClasses.selected}`]: {
//             backgroundColor: alpha(theme.palette.primary.dark, 0.04),
//             '&:hover': {
//               backgroundColor: alpha(theme.palette.primary.dark, 0.08),
//             },
//           },
//           '&:last-of-type': {
//             [`& .${tableCellClasses.root}`]: {
//               borderColor: 'transparent',
//             },
//           },
//         },
//       },
//     },
//     MuiTable: {
//       styleOverrides: {
//         root: {
//           fontSize: 10, // Ensure small font size for overall table
//         },
//       },
//     },
//     MuiTableCell: {
//       styleOverrides: {
//         root: {
//           fontSize: 11.8, // Smaller font size for table cells
//           padding: theme.spacing(0.5), // Compact padding for all table cells
//           borderBottomStyle: 'dashed',
//           paddingLeft: '10px', // Add 2px spacing from the left
//         },
//         head: {
//           fontSize: '12px !important', // Force 11px for table heading
//           color: theme.palette.text.secondary,
//           fontWeight: theme.typography.fontWeightSemiBold,
//           backgroundColor: theme.palette.background.neutral,
//           // padding: theme.spacing(1.1), // Compact padding for all table cells
//           whiteSpace: 'nowrap', // Prevent text from wrapping and adding unnecessary height
//           borderBottomStyle: 'dashed',
//           paddingLeft: '10px', // Add 2px spacing from the left in the header
//           // textAlign: 'left', // Explicitly set text alignment to left for header
//         },
//         stickyHeader: {
//           backgroundColor: theme.palette.background.paper,
//           backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.neutral} 0%, ${theme.palette.background.neutral} 100%)`,
//         },
//         paddingCheckbox: {
//           paddingLeft: theme.spacing(1), // Minimal padding for checkbox cells
//         },
//       },
//     },
//     MuiTablePagination: {
//       styleOverrides: {
//         root: {
//           width: '100%',
//         },
//         toolbar: {
//           height: 64,
//         },
//         actions: {
//           marginRight: 8,
//         },
//         select: {
//           paddingLeft: 8,
//           '&:focus': {
//             borderRadius: theme.shape.borderRadius,
//           },
//         },
//         selectIcon: {
//           right: 4,
//           width: 16,
//           height: 16,
//           top: 'calc(50% - 8px)',
//         },
//       },
//     },
//   };
// }

// export function table(theme) {
//   return {
//     MuiTableContainer: {
//       styleOverrides: {
//         root: {
//           position: 'relative',
//         },
//       },
//     },
//     MuiTableRow: {
//       styleOverrides: {
//         root: {
//           [`&.${tableRowClasses.selected}`]: {
//             backgroundColor: alpha(theme.palette.primary.dark, 0.04),
//             '&:hover': {
//               backgroundColor: alpha(theme.palette.primary.dark, 0.08),
//             },
//           },
//           '&:last-of-type': {
//             [`& .${tableCellClasses.root}`]: {
//               borderBottom: 'none', // Remove bottom border for the last row
//             },
//           },
//         },
//       },
//     },
//     MuiTable: {
//       styleOverrides: {
//         root: {
//           fontSize: '10px', // Small font size for the entire table
//         },
//       },
//     },
//     MuiTableCell: {
//       styleOverrides: {
//         root: {
//           fontSize: '11.8px', // Smaller font size for table cells
//           borderBottom: `1px dashed ${theme.palette.divider}`, // Dashed bottom border
//           padding: theme.spacing(0.5), // Compact padding for table cells
//           paddingLeft: '8px', // Add spacing from the left
//           paddingRight: '8px', // Add spacing from the right
//           borderRight: `0.1px dashed ${theme.palette.divider}`, // Right border
//           '&:first-child': {
//             paddingLeft: '12px', // Extra padding for the first header cell
//           },
//           '&:last-child': {
//             border: 'none', // Remove right border for the last cell
//           },
//         },
//         head: {
//           fontSize: '12px !important', // Font size for headers
//           color: theme.palette.text.secondary,
//           border:'none',
//           fontWeight: theme.typography.fontWeightSemiBold,
//           backgroundColor: theme.palette.background.neutral,
//           whiteSpace: 'nowrap', // Prevent text wrapping
//           padding: theme.spacing(1), // Padding for header cells
//           paddingLeft: '8px', // Add spacing from the left
//           paddingRight: '8px', // Add spacing from the right
//           '&:last-child': {
//             border: 'none', // Remove right border for the last header cell
//           },
//           '&:first-child': {
//             paddingLeft: '12px', // Extra padding for the first header cell
//           },
//         },
//         stickyHeader: {
//           backgroundColor: theme.palette.background.paper,
//           backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.neutral} 0%, ${theme.palette.background.neutral} 100%)`,
//         },
//         paddingCheckbox: {
//           paddingLeft: theme.spacing(1), // Minimal padding for checkbox cells
//         },
//       },
//     },
//     MuiTablePagination: {
//       styleOverrides: {
//         root: {
//           width: '100%',
//           padding: theme.spacing(0.5), // Match header padding
//           borderTop: `1px dashed ${theme.palette.divider}`, // Add a top border
//         },
//         toolbar: {
//           height: 'auto', // Allow flexibility in height
//           padding: theme.spacing(0, 1), // Match horizontal padding with header
//           minHeight: 48, // Set a minimum height for the toolbar
//         },
//         actions: {
//           marginRight: theme.spacing(1),
//         },
//         select: {
//           paddingLeft: theme.spacing(1),
//           '&:focus': {
//             borderRadius: theme.shape.borderRadius,
//           },
//         },
//         selectIcon: {
//           right: theme.spacing(0.5),
//           width: 16,
//           height: 16,
//           top: 'calc(50% - 8px)',
//         },
//       },
//     },
//   };
// }

export function table(theme) {
  return {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          position: 'relative',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          [`&.${tableRowClasses.selected}`]: {
            backgroundColor: alpha(theme.palette.primary.dark, 0.04),
            '&:hover': {
              backgroundColor: alpha(theme.palette.primary.dark, 0.08),
            },
          },
          '&:last-of-type': {
            [`& .${tableCellClasses.root}`]: {
              borderBottom: 'none', // Remove bottom border for the last row
            },
          },
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          fontSize: '10px', // Small font size for the entire table
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '11.8px', // Smaller font size for table cells
          borderBottom: `1px dashed ${theme.palette.divider}`, // Dashed bottom border
          padding: theme.spacing(0.5), // Compact padding for table cells
          paddingLeft: '8px', // Add spacing from the left
          paddingRight: '8px', // Add spacing from the right
          borderRight: `0.1px dashed ${theme.palette.divider}`, // Right border
          '&:first-child': {
            paddingLeft: '12px', // Extra padding for the first header cell
            paddingRight: '12px', // Extra padding for the first header cell
          },
          '&:last-child': {
            borderLeft: 'none', // Remove Left border for the last cell
            borderRight: 'none', // Remove right border for the last cell
            textAlign: 'center', // Center-align the content of the last cell
            verticalAlign: 'middle', // Align content vertically to the middle
          },
          '&:nth-last-child(2)': {
            // borderRight: 'none', // Remove the right border for the second-to-last cell
            borderRight: `0.1px dashed ${theme.palette.divider}`, // Right border
          },
        },
        head: {
          fontSize: '12px !important', // Font size for headers
          color: theme.palette.text.secondary,
          border: 'none',
          fontWeight: theme.typography.fontWeightSemiBold,
          backgroundColor: theme.palette.background.neutral,
          borderRight: `0.1px dashed ${theme.palette.divider}`, // Right border
          whiteSpace: 'nowrap', // Prevent text wrapping
          padding: theme.spacing(1.1), // Padding for header cells
          paddingLeft: '8px', // Add spacing from the left
          paddingRight: '8px', // Add spacing from the right
          '&:last-child': {
            border: 'none', // Remove right border for the last header cell
            textAlign: 'center', // Explicitly set text alignment to left for header
          },
          '&:first-child': {
            paddingLeft: '12px', // Extra padding for the first header cell
          },
        },
        stickyHeader: {
          backgroundColor: theme.palette.background.paper,
          backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.neutral} 0%, ${theme.palette.background.neutral} 100%)`,
        },
        paddingCheckbox: {
          paddingLeft: theme.spacing(1), // Minimal padding for checkbox cells
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          width: '100%',
          padding: theme.spacing(0.5), // Match header padding
          borderTop: `1px dashed ${theme.palette.divider}`, // Add a dashed top border
        },
        toolbar: {
          height: 'auto', // Allow flexibility in height
          padding: theme.spacing(0, 1), // Match horizontal padding with header
          minHeight: '48px !important', // Set a minimum height for the toolbar
        },
        actions: {
          marginRight: theme.spacing(1),
        },
        select: {
          paddingLeft: theme.spacing(1),
          '&:focus': {
            borderRadius: theme.shape.borderRadius,
          },
        },
        selectIcon: {
          right: theme.spacing(0.5),
          width: 16,
          height: 16,
          top: 'calc(50% - 8px)',
        },
      },
    },
  };
}
